import {NG_EVENT_PLUGINS} from "@taiga-ui/event-plugins";
import {provideAnimations} from "@angular/platform-browser/animations";
import {ApplicationConfig, ErrorHandler, inject, provideEnvironmentInitializer, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {authInterceptor} from './core/interceptors/auth.interceptor';
import {PreventNumberScrollService} from './core/services/prevent-number-scroll.service';
import { TUI_ALERT_POSITION } from "@taiga-ui/core";
import { AppErrorHandler } from './core/error/app-error.handler';
import { SessionIntegrityService } from './core/services/session-integrity.service';

export const appConfig: ApplicationConfig = {
  providers: [
    // {
    //   provide: TUI_ALERT_POSITION,
    //   useValue: 'top-middle'
    // },
    provideAnimations(),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    NG_EVENT_PLUGINS,
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    { provide: ErrorHandler, useClass: AppErrorHandler },
    provideEnvironmentInitializer(() => {
      inject(PreventNumberScrollService);
      inject(SessionIntegrityService).start();
    }),
  ],
};
